import axios from 'axios'

function initialState() {
  return {
    orders: [],
    loading: true,
    error: null
  }
}

export default {
  namespaced: true,
  state: initialState(),
  mutations: {
    setOrders(state, orders) {
      state.orders = [...orders]
    },
    add(state, order) {
      state.orders = [...state.orders, order]
    },
    delete(state, order) {
      state.orders = state.orders.filter(f => f._id != order._id)
    },
    update(state, order) {
      let index = state.orders.findIndex(f => f._id === order._id)
      state.orders[index] = order
    },
    setLoading(state, loading) {
      state.loading = loading
    },
    clear(state) {
      const initial = initialState()
      state = initial
    },
    setError(state, error) {
      state.error = error
    }
  },
  actions: {
    clear({ commit }) {
      commit('clear')
    },
    async load({ commit }) {
      commit('setLoading', true)
      commit('setError', null)
      try {
        await axios
          .get(`${process.env.VUE_APP_API_URL}/orders`)
          .then(res => res.data.orders)
          .then(orders => {
            commit('setOrders', orders)
          })
      } catch (err) {
        commit('setError', err)
      } finally {
        commit('setLoading', false)
      }
    },
    async loadUsersOrders({ commit }, userId) {
      commit('setLoading', true)
      commit('setError', null)
      try {
        await axios
          .get(`${process.env.VUE_APP_API_URL}/orders/${userId}/all_orders`)
          .then(res => res.data.orders)
          .then(orders => {
            commit('setOrders', orders)
          })
      } catch (err) {
        commit('setError', err)
      } finally {
        commit('setLoading', false)
      }
    },
    async add({ commit }, order) {
      commit('setLoading', true)
      commit('setError', null)
      try {
        axios.post(`${process.env.VUE_APP_API_URL}/orders/add`, { order })
        return true
      } catch (err) {
        commit('setError', err)
        return false
      } finally {
        commit('setLoading', false)
      }
    },
    async update({ commit }, order) {
      commit('setError', null)
      try {
        await axios.put(`${process.env.VUE_APP_API_URL}/orders`, order)
        commit('update', order)
      } catch (err) {
        commit('setError', err)
      }
    },
    async delete({ commit }, order) {
      commit('setLoading', true)
      commit('setError', null)
      try {
        await axios.delete(`${process.env.VUE_APP_API_URL}/orders/${order._id}`)
        commit('delete', order)
      } catch (err) {
        commit('setError', err)
      } finally {
        commit('setLoading', false)
      }
    }
  },
  getters: {
    allOrders: state => {
      return state.orders
    },
    isLoading: state => {
      return state.loading
    },
    isError: state => {
      return state.error
    }
  }
}
